import axios from 'axios';
import ISchedulerSettings from '../../Models/Scheduling/SchedulerSettings.model';
import { apiString } from '../../utils/constants';

export const getSchedulerSettings = async (): Promise<ISchedulerSettings> => {
    const response = await axios.get<ISchedulerSettings>(`${apiString}/SchedulerSettings/GetSchedulerSettings`);
    return response.data;
};

export const saveSchedulerSettings = async (settings: ISchedulerSettings): Promise<void> => {
    await axios.post(`${apiString}/SchedulerSettings/SaveSchedulerSettings`, settings);
};
